import React from 'react';

const partners = [
  { name: "St. Jude Children's Research Hospital", logo: "https://www.stjude.org/etc/designs/stjude/primaryLogo.svg" },
  { name: "Feeding America", logo: "https://upload.wikimedia.org/wikipedia/commons/9/9e/Feeding_America_logo.svg" },
  { name: "Wounded Warrior Project", logo: "https://www.woundedwarriorproject.org/themes/custom/wwp/logo.svg" },
  { name: "Disabled American Veterans", logo: null },
  { name: "Amazon", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" },
  { name: "Google", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" },
  { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
  { name: "Adobe", logo: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Adobe_Corporate_logo.svg" },
  { name: "Salesforce", logo: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg" },
  { name: "Prestigious Companies", logo: null },
  { name: "Prestigious Travel Club Inc", logo: null },
  { name: "Easy Quick Fund", logo: null },
  { name: "Prestigious Marketing", logo: null },
];

const LogoItem = ({ partner }) => {
  const [imgFailed, setImgFailed] = React.useState(false);

  if (partner.logo && !imgFailed) {
    return (
      <div className="flex items-center justify-center mx-6 sm:mx-12 flex-shrink-0 select-none">
        <img
          src={partner.logo}
          alt={partner.name}
          className="h-6 sm:h-8 w-auto max-w-[120px] sm:max-w-[160px] object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center mx-6 sm:mx-12 flex-shrink-0 select-none">
      <span
        className="text-base sm:text-xl font-semibold tracking-tight text-slate-400 hover:text-[#1E3A8A] transition-colors duration-500 whitespace-nowrap"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        {partner.name}
      </span>
    </div>
  );
};

const PartnerMarquee = () => {
  // Double the list for seamless looping
  const doubled = [...partners, ...partners];

  return (
    <section className="py-16 bg-white border-y border-slate-100 overflow-hidden" data-testid="partner-marquee">
      <div className="text-center mb-10">
        <p className="text-xs font-bold tracking-[0.3em] uppercase text-slate-400">
          Trusted Partners & Family
        </p>
      </div>

      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Scrolling track */}
        <div className="flex animate-marquee">
          {doubled.map((partner, idx) => (
            <LogoItem key={`${partner.name}-${idx}`} partner={partner} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerMarquee;
